import { StockVideo } from 'types/StockVideo';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserPaidItems } from 'modules/oneTimePayment';
import { throttle } from 'throttle-debounce';
import { useAsync, useDebounce } from 'react-use';
import { getStockVideos } from 'utils/apiWrapper';
import { Licenses } from 'types/Licenses';
import { UseStockVideoReturn } from './types';

const LIMIT = 40;

export const useStockVideos = (): UseStockVideoReturn => {
  const [videos, setVideos] = useState<StockVideo[]>([]);
  const [videosLimit, setVideosLimit] = useState(LIMIT);
  const userPaidItems = useSelector(getUserPaidItems);
  const [query, setQuery] = useState<string>('');
  const [innerQuery, setInnerQuery] = useState<string>(query);
  const [isCommercial, setIsCommercial] = useState<StockVideo['isCommercial']>(true);
  const [isQueryChanged, setIsQueryChanged] = useState<boolean>(false);

  // TODO: integration with Shutterstock: should we delete it or make it someday?
  // const [stockVideos, shutterstockVideos] = await Promise.all([
  //   getStockVideos({ searchInput, commercial: isCommercial, limit: videosLimit }),
  //   getShutterstockVideos(userKey, searchInput),
  //   []
  // ]);
  // const fixedPayedShutterstock = shutterstockVideos.map(item => ({
  //   ...item,
  //   license: userPaidItems.find(payedItem => payedItem.id === item.id)
  //     ? Licenses.StockVideoFree
  //     : Licenses.PhotoChooserPremium
  // }));
  // return shuffleVideos(stockVideos, fixedPayedShutterstock, 3);

  useEffect(() => {
    setVideos([]);
    setIsQueryChanged(true);
  }, [query]);

  useDebounce(
    () => {
      setVideosLimit(LIMIT);
      setInnerQuery(query);
      setIsQueryChanged(false);
    },
    1000,
    [query]
  );

  const requestNextPage = useCallback(
    throttle(1000, () => setVideosLimit(prevState => prevState + LIMIT)),
    []
  );

  const { loading, value } = useAsync(async () => {
    try {
      const stockVideos = await getStockVideos({
        query: innerQuery,
        commercial: isCommercial,
        limit: videosLimit
      });
      return stockVideos.map(item => ({
        ...item,
        license: userPaidItems.find(payedItem => payedItem.id === item.id)
          ? Licenses.StockVideoFree
          : Licenses.PhotoChooserPremium
      }));
    } catch (_) {
      return [];
    }
  }, [innerQuery, isCommercial, videosLimit, userPaidItems]);

  useEffect(() => {
    if (value !== undefined) {
      setVideos(value);
    }
  }, [value]);

  return {
    query,
    setQuery,
    isCommercial,
    setIsCommercial,
    requestNextPage,
    loading: loading || isQueryChanged,
    videos
  };
};
